export default function extractLoansFromSearchResults(searchResults) {
  const loans = [];

  if (searchResults && searchResults.loans && searchResults.loans.length) {
    loans.push(...searchResults.loans);
  }

  if (
    searchResults &&
    searchResults.properties &&
    searchResults.properties.length
  ) {
    searchResults.properties.forEach((property) => {
      if (property._loan) {
        loans.push(property._loan);
      }
    });
  }

  if (
    searchResults &&
    searchResults.borrowers &&
    searchResults.borrowers.length
  ) {
    searchResults.borrowers.forEach((borrower) => {
      if (borrower._loans && borrower._loans.length) {
        loans.push(...borrower._loans);
      }
    });
  }

  return loans;
}
